import script from "./ContentEditable.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentEditable.vue?vue&type=script&setup=true&lang=js"

import "./ContentEditable.vue?vue&type=style&index=0&id=0cecda1c&lang=scss"

const __exports__ = script;

export default __exports__